import React, {useEffect, useState} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles, options_segment, valueToOption} from "../../atom/Apollo_styles";
import {
  accountgroups_path,
  apollo_accountgroup_path,
  accountgroupdetail_path,
  accounteditapollo_path,
} from "../../atom/Apollo_links";
import {AccountGroup, AccountGroupRequest} from "../../organism/ACCOUNT/AccountModel";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import { APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission } from "../../atom/Apollo_Authorization";

import {useHistory, useParams} from "react-router-dom";
import {useForm} from "react-hook-form";
import {ApolloContext} from "../../atom/Apollo_Context";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import {APOLLO_GROUP_ADMIN} from "../../atom/Apollo_Authorization";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import ApolloSelectBillingResource, {PropsSelectBillingResource} from "../../molecule/ACCOUNT/Apollo_SelectBillingResource";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../atom/Apollo_Breadcrumbs2";
import moment from "moment";
import {checkCommonInvalidTextChar, checkInvalidCharForName} from "../../common/Apollo_CommonUtil";
// メッセージ定義
import {
  GetMessage,
  UI_ACCOUNT_GROUP_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

/*
    画面名：アカウントグループ編集画面
 */
const AccountGroupEdit: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  // 0: 新規　、　id：編集
  const {accountgroupid} = useParams<{accountgroupid: string}>();
  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {register, handleSubmit, errors, formState, setError, clearErrors} = useForm();
  // ダブルクリック対応
  const processing = React.useRef(false);
  // 操作前データ
  const beforeData = React.useRef<any>(null);
  const resultData = React.useRef<any>(null);
  const resultApi = React.useRef(-1);
  const logTime = React.useRef("");
  const [label, setLabel] = React.useState("");

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 9,
    breadId: accountgroupid === "0" ? 2 : 4,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const [accountgroup, setAccountgroup] = useState<AccountGroup>({
    accountgroupId: 0,
    accountgroupName: "",
    platforms: [],
    status: 0,
    billingId: 1,
    billingName: "",
    creditLimitAmount: 0,
    customSegmentFlg: 1,
    geoSegmentFlg: 1,
    createdAt: "",
    createdBy: "",
    modifiedAt: "",
    modifiedBy: "",
  });

  const [billingResourceTemp, setBillingResourceTemp] = React.useState(0);

  // 請求リソース選択引数
  var propsSelectBillingResource : PropsSelectBillingResource = {
    defaultValue: 1,
    setValue: setBillingResourceTemp,
    value: billingResourceTemp,
    isDisabled: accountgroupid === "0" ? false : true,
    required: true,
    accountgroup: accountgroup,
    setLabel: setLabel,
  };

  // アカウントグループデータ取得
  useEffect(() => {
    // 新規は取得しない
    if (accountgroupid !== "0") {
      const url = apollo_accountgroup_path + "/" + accountgroupid;
      ApolloAxios.get(url).then(response => {
        if (response.data.resultCode === 0) {
          // 操作前データ保存
          beforeData.current = JSON.parse(JSON.stringify(response.data.result));
          setAccountgroup(response.data.result);
          setBillingResourceTemp(response.data.result.billingId);
        } else {
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"E","0"),
              loading: false,
            }
          });
        }
      }).catch((err) => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"E","0"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      })
    }
  }, [accountgroupid]);

  const handleChangeSeg = (event: any) => {
    accountgroup.customSegmentFlg = event.target.value;
    // setAccountgroup(accountgroup);
    event.target.value ? clearErrors("segment") :
      setError("segment", {
        type: "manual",
        message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"V","0"),
      });
  };

  const handleChangeGeoSeg = (event: any) => {
    accountgroup.geoSegmentFlg = event.target.value;
    // setAccountgroup(accountgroup);
    event.target.value ? clearErrors("segment") :
      setError("segment", {
        type: "manual",
        message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"V","0"),
      });
  };

  const onSubmit = handleSubmit(async (body: any) => {
    // フォーム送信中なら弾く
    if (formState.isSubmitting) return;
    // processingがtrueなら弾く
    if (processing.current) return;
    // 処理開始時にprocessingをtrueにする
    processing.current = true;
    // エラークリア
    clearErrors(["segment"]);
    // アカウントグループ名セット
    accountgroup.accountgroupName = body.accountgroupName;
    // カスタムセグメント操作権限チェック
    if (!(accountgroup?.customSegmentFlg)) {
      setError("segment", {
        type: "manual",
        message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"V","0"),
      })
      return;
    }
    // ジオセグメント操作権限チェック
    if (!(accountgroup?.geoSegmentFlg)) {
      setError("segment", {
        type: "manual",
        message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"V","0"),
      })
      return;
    }
    // 請求リソースチェック
    if (!(billingResourceTemp)) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"V","1"),
        }
      });
    return;
    }
    // アカウントグループ登録・更新リクエスト作成
    const agReq: AccountGroupRequest = {
      accountgroupName: accountgroup?.accountgroupName,
      billingId: (billingResourceTemp ? billingResourceTemp : accountgroup?.billingId) + '',
      customSegmentFlg: accountgroup?.customSegmentFlg + '',
      geoSegmentFlg: accountgroup?.geoSegmentFlg + '',
    }

    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ出力(更新)
    resultApi.current = 0;
    writeLog();
    if (accountgroupid === "0") {
      // 作成
      const url = apollo_accountgroup_path;
      ApolloAxios.post(url, agReq).then(response => {
        if (response.data.resultCode === 0) {
          // 操作ログ(成功)
          resultApi.current = 1;
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"I","0"),
            }
          });
          let result = accountgroupid === "0" ? response.data.result : response.data;
          resultData.current = response.data.result;
          dispatch({
            type: "setAccount",
            payload: {
              ...state,
              userprofile: result.userprofile,
              authorization: result.authorization,
              apolloList: result.apolloList,
              accesstoken: result.accesstoken,
              current: {
                accountGroupId: result.accountGroupId,
                accountGroupName: body.accountgroupName,
                accountId: 0,
                accountName: "",
                trackerId: "",
                campaignId: 0,
                roleAuthorization: accountgroupid === "0" ? 0 : state.current.roleAuthorization,
                customSegment: body.customSegmentFlg,
                geoSegment: body.geoSegmentFlg,
              }
            }
          });
          history.push(accounteditapollo_path + result.accountGroupId + "/0");
        } else {
          console.log(response.data.message);
          setmsg({
            type: "all",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"E","1"),
              loading: false
            }
          });
        }
      }).catch(err => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"E","1"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        // 処理終了時にprocessingをfalseにする
        processing.current = false;
      });
    } else {
      // 更新
      const url = apollo_accountgroup_path + "/" + accountgroupid;
      ApolloAxios.put(url, agReq).then(response => {
        if (response.data.resultCode === 0) {
          // 操作ログ(成功)
          resultApi.current = 1;
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "success",
              message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"I","1")
            }
          });
          let result = response.data;
          dispatch({
            type: "setAccount",
            payload: {
              ...state,
              userprofile: result.userprofile,
              authorization: result.authorization,
              apolloList: result.apolloList,
              accesstoken: result.accesstoken,
              current: {
                accountGroupId: accountgroupid === "0" ? result.accountGroupId : Number(accountgroupid),
                accountGroupName: body.accountgroupName,
                accountId: 0,
                accountName: "",
                trackerId: "",
                campaignId: 0,
                roleAuthorization: accountgroupid === "0" ? APOLLO_GROUP_ADMIN : state.current.roleAuthorization,
                customSegment: body.customSegmentFlg,
                geoSegment: body.geoSegmentFlg,
              }
            }
          });
          history.push(accountgroupdetail_path + accountgroupid);
        } else {
          // 操作ログ(失敗)
          resultApi.current = 9;
          console.log(response.data.message);
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"E","2"),
            }
          });
        }
      }).catch(err => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, GetMessage("0",UI_ACCOUNT_GROUP_EDIT,"E","2"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        // 処理終了時にprocessingをfalseにする
        processing.current = false;
      });
    }
  });

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    // 項目リスト
    const itemList1: ItemList[] = [
      // {
      //   key: "アカウントグループID",
      //   beforeValue: accountgroupid === "0" ? "" : accountgroup.accountgroupId + "",
      //   afterValue: accountgroupid === "0" ? resultData.current ? resultData.current.accountGroupId : "" : accountgroup.accountgroupId + "",
      // },
      {
        key: "アカウントグループ名",
        beforeValue: accountgroupid === "0" ? "" : beforeData.current.accountgroupName,
        afterValue: accountgroup.accountgroupName,
      },
    ];
    // 項目リスト
    const itemList2: ItemList[] = [
      {
        key: "請求リソース",
        beforeValue: accountgroupid === "0" ? "" : label + "",
        afterValue: label + "",
      },
    ];
    // 項目リスト
    const itemList3: ItemList[] = [
      {
        key: "カスタムセグメント操作権限",
        beforeValue: accountgroupid === "0" ? "" : valueToOption(beforeData.current.customSegmentFlg, options_segment).label + "",
        afterValue: valueToOption(accountgroup.customSegmentFlg, options_segment).label + "",
      },
      // {
      //   key: "ジオセグメント操作権限 ",
      //   beforeValue: accountgroupid === "0" ? "" : valueToOption(beforeData.current.geoSegmentFlg, options_segment).label + "",
      //   afterValue: valueToOption(accountgroup.geoSegmentFlg, options_segment).label + "",
      // },
    ];
    var itemList: ItemList[] = [];
    if (accountgroupid === "0") {
      itemList = itemList1.concat(itemList2.concat(itemList3));
    } else {
      itemList = itemList1.concat(itemList3);
    }
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: accountgroupid === "0" ? 0 : state.current.accountGroupId, // アカウントグループID
      accountGroupName: accountgroupid === "0" ? "" : state.current.accountGroupName, // アカウントグループ名
      accountID: accountgroupid === "0" ? 0 : state.current.accountId, // 広告主アカウントID
      accountName: accountgroupid === "0" ? "" : state.current.accountName, // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: accountgroupid === "0" ? "アカウントグループ作成画面" : "アカウントグループ編集画面", // 操作画面名称 〇〇画面
      category: "アカウントグループ", // 操作対象 キャンペーン / セグメント etc...
      actionType: accountgroupid === "0" ? "作成" : "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : resultData.current ? resultData.current.accountGroupId + "" : accountgroupid + "", // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "アカウントグループID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  // 戻るハンドラ
  const handelGoback = () => {
    history.push(accountgroupid === "0" ? accountgroups_path : accountgroupdetail_path + accountgroupid);
  };
  
  return (
    <GenericTemplate title="">
      <ApolloPageUsagePermission role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <form noValidate onSubmit={onSubmit} onKeyDown={e => {
          if (e.key === 'Enter') e.preventDefault();
        }}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid   item xs={12}>
                  <TextField
                    required
                    id="accountgroupName"
                    name="accountgroupName"
                    label="アカウントグループ名"
                    key={accountgroup?.accountgroupName ? "Loaded" : "Loading"}
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      },
                      validate: (e: string) => {
                        const errorMessage = checkInvalidCharForName(e)
                        if(errorMessage) {
                          return errorMessage
                        }
                      },
                    })}
                    fullWidth
                    defaultValue={accountgroup?.accountgroupName}
                    autoComplete="広告代理店名"
                    helperText={errors.accountgroupName && errors.accountgroupName.message}
                    error={errors.accountgroupName ? true : false}
                  />
                </Grid>

                {/* 請求リソース情報 */}
                <ApolloSelectBillingResource propsSelect={propsSelectBillingResource}/>

                {/* カスタムセグメント操作権限 */}
                <Grid item xs={12}>
                  <FormControl error={errors.segment ? true : false} fullWidth>
                    <InputLabel id="customSegmentFlg">カスタムセグメント操作権限 *</InputLabel>
                    <Select
                      labelId="customSegmentFlg"
                      id="customSegmentFlg"
                      name="customSegmentFlg"
                      value={accountgroup?.customSegmentFlg}
                      onChange={handleChangeSeg}
                    >
                      {
                        options_segment.map((seg: any, index: any) =>
                          <MenuItem value={seg.value}>{seg.label}</MenuItem>
                        )
                      }
                    </Select>
                    <FormHelperText>{errors.segment && errors.segment.message}</FormHelperText>
                  </FormControl>
                </Grid>
                {/* ジオセグメント操作権限 */}
                {/* <Grid item xs={12}>
                  <FormControl error={errors.segment ? true : false} fullWidth>
                    <InputLabel id="geoSegmentFlg">ジオセグメント操作権限 *</InputLabel>
                    <Select
                      labelId="geoSegmentFlg"
                      id="geoSegmentFlg"
                      name="geoSegmentFlg"
                      value={accountgroup?.geoSegmentFlg}
                      onChange={handleChangeGeoSeg}
                    >
                      {
                        options_segment.map((seg: any, index: any) =>
                          <MenuItem value={seg.value}>{seg.label}</MenuItem>
                        )
                      }
                    </Select>
                    <FormHelperText>{errors.segment && errors.segment.message}</FormHelperText>
                  </FormControl>
                </Grid> */}

              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <React.Fragment>
                <Button
                  type="submit"
                  color="primary"
                  className={classes.button}
                  onClick={onSubmit}
                  variant="contained"
                  disabled={formState.isSubmitting || processing.current}
                >
                  {accountgroupid === "0" ? "作成" : "更新"}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handelGoback}
                  className={classes.button}
                >
                  戻る
                </Button>
              </React.Fragment>
            </CardActions>
          </Card>
        </form>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default AccountGroupEdit;
